import { Stack } from '@mui/material';
import React from 'react';

import { PageHeaderLayout } from '@/shared/components';
import { useMedia } from '@/shared/hooks';

const DiscoverPage: React.FC = () => {
  const { isSxScreen } = useMedia();

  return (
    <Stack sx={{ height: '100%' }} gap={isSxScreen ? '1rem' : ''}>
      <PageHeaderLayout headerName={'Discover Page'} />
    </Stack>
  );
};

export default DiscoverPage;